import MSCartesian from '@fusioncharts/charts/src/chart/_internal/mscartesian';
import ColumnDataset from '@fusioncharts/charts/src/dataset/column';
import MultiSeriesManager from '@fusioncharts/charts/src/dataset/groups/column-multiseries';
let COLUMN = 'column';

class InverseMSColumn2d extends MSCartesian {
  /**
   * Provides the name of the chart extension
   *
   * @static
   * @return {string} The name of the chart extension
   */
  static getName () {
    return 'InverseMSColumn2d';
  }

  /**
   * Sets the name of the component
   * @return {string} name
   */
  getName () {
    return 'InverseMSColumn2d';
  }
  /**
   * parse defualt configuration of the chart
   */
  __setDefaultConfig () {
    super.__setDefaultConfig();
    let config = this.config;
    config.defaultDatasetType = COLUMN;
    config.isInverse = true;
    config.enablemousetracking = true;
  }
  getDSdef () {
    return ColumnDataset;
  }
  getDSGroupdef () {
    return MultiSeriesManager;
  }
}
export default InverseMSColumn2d;
